import React, { useState, useMemo } from "react";
import { Form, Button, Collapse, DatePicker, message } from "antd";
import moment from "moment";

import HmgMainDropdown from "../components/Common/DataAttachedElements/HmgDropdown";
import ProjectDropdown from "../components/Common/DataAttachedElements/ProjectDropdown";
import HotelDropdown from "../components/Common/DataAttachedElements/HotelDropdown";

import { formItemLayout, formItemLayoutWithOutLabel } from "../utils/UI";
import UserLoggedDetailsTable from "../components/Users/UserLoggedDetails/UserLoggedDetailsTable";
import { useGetSSOLoggedUsers } from "../hooks/sso";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const LoggedUserDetails = () => {
  const [hmg, setHmg] = useState();
  const [project, setProject] = useState();
  const [hotels, setHotels] = useState([]);
  const [createdAt, setCreatedAt] = useState();
  const [lastLogin, setLastLogin] = useState();


  const submitData = useMemo(() => {
    // pagination is not used
    const perPage = "100";
    const page = "-1"; // this param is getting all sso users to proceed.
    const order = 1;

    return {
      order,
      perPage,
      page,
      created_at: createdAt,
      last_login: lastLogin,
      hotels,
    };
  }, [hotels, createdAt, lastLogin]);

  const { data, refetch, isLoading, isFetching } = useGetSSOLoggedUsers(
    submitData,
    {
      enabled: false,
      onSuccess: () => {
        message.success("All users are successfully fetched");
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "Server Error", 5);
      },
      retry: false,
    },
  );

  const tableData = useMemo(() => {
    const order = 1;
    const sort = "last_login";
    if (data) {
      return data
        .map((item) => ({
          ...item,
          connection:
            item.identities === undefined
              ? "Unavailable"
              : item.identities[0].connection,
          last_login: moment(item.last_login)
            .local()
            .format("YYYY-MM-DD h:mm:ss a"),
          created_at: moment(item.created_at)
            .local()
            .format("YYYY-MM-DD h:mm:ss a"),
        }))
        .sort((a, b) =>
          order === 1
            ? a[sort] > b[sort]
              ? 1
              : -1
            : b[sort] > a[sort]
            ? 1
            : -1,
        );
    }
    return [];
  }, [data]);

  return (
    <div className="container_ab">
      <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
        <Panel header="USER LOGGED DETAILS" key="1">
          <HmgMainDropdown value={hmg} onChange={setHmg} />
          <ProjectDropdown hmgId={hmg} value={project} onChange={setProject} />
          <HotelDropdown
            value={hotels}
            onChange={setHotels}
            projectId={project}
            multiple
          />
          <Form.Item {...formItemLayout} label="User Account Creation Date">
            <RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
              value={createdAt}
              onChange={setCreatedAt}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="User Last Login Date">
            <RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
              value={lastLogin}
              onChange={setLastLogin}
            />
          </Form.Item>
          <Form.Item {...formItemLayoutWithOutLabel} className="btn-section">
            <Button
              type="primary"
              onClick={refetch}
              loading={isLoading || isFetching}
              disabled={!hotels?.length > 0}
            >
              Submit
            </Button>
          </Form.Item>
          <UserLoggedDetailsTable dataSource={tableData} />
        </Panel>
      </Collapse>
    </div>
  );
};
export default LoggedUserDetails;
